import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px 20px 20px;
  gap: 32px;
  isolation: isolate;

  width: 1076px;
  height: auto;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  margin: 0 auto;

  @media (max-width: 1200px) {
    width: 100%;
    max-width: 1076px;
    height: auto;
    gap: 32px;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 32px;

  width: 800px;

  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 0;

  @media (max-width: 768px) {
    width: 100%;
    gap: 24px;
  }
`;

export const TitleDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 20px;

  width: 800px;

  flex: none;
  order: 0;
  flex-grow: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Title = styled.h1`
  width: 800px;
  height: auto;

  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 52px;
  text-align: center;

  color: #000e2a;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 40px;
    height: auto;
    width: 100%;
  }
`;

export const Description = styled.p`
  width: 548px;
  height: 42px;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;

  color: #353a46;

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 20px;
  gap: 10px;

  width: 205px;
  height: 48px;

  background: #2266ef;
  border-radius: 32px;

  flex: none;
  order: 1;
  flex-grow: 0;

  @media (max-width: 768px) {
    width: auto;
    height: auto;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;
  gap: 16px;

  width: auto;
  height: 48px;

  flex: none;
  order: 1;
  flex-grow: 0;
`;

export const PrimaryActionButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 32px;
  gap: 10px;

  width: max-content;
  height: 48px;

  background: #2266ef;
  border-radius: 32px;
  border: none;

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #ffffff;

  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const SecondaryActionButton = styled.button`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  gap: 10px;

  width: max-content;
  height: 48px;

  border: 1px solid #d3e0fc;
  border-radius: 32px;
  background: #ffffff;

  font-family: 'Mona Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #2266ef;

  cursor: pointer;

  &:hover {
    background: #f2f7ff;
  }
`;

export const VideoSectionContainer = styled.div`
  position: relative;
  width: 680px;
  height: 380px;

  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;

  background: #edf8fe;
  border-radius: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 614px;
  }
`;

export const VideoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

export const PlayButtonOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  transition: background-color 0.3s ease;
  top: 0;
  left: 0;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const PlayButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;

  width: 80px;
  height: 80px;

  background: linear-gradient(
    138.69deg,
    rgba(34, 102, 239, 0.65) 18.15%,
    rgba(108, 46, 242, 0.65) 78.01%
  );
  border-radius: 48px;

  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;

  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 64px;
    height: 64px;
    border-radius: 32px;
  }
`;

export const PlayIcon = styled.div`
  width: 0;
  height: 0;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 22px solid #ffffff;
  margin-left: 4px;

  flex: none;
  order: 0;
  flex-grow: 0;

  @media (max-width: 768px) {
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 16px solid #ffffff;
    margin-left: 3px;
  }
`;
